import { Key, ReactChild, ReactFragment, ReactPortal } from "react";
import { HiTicket as LinkIcon } from "react-icons/hi";
import { urlFor } from '@/lib/sanity'

export function EventAccessTicket({ products, image, url }) {
  return (
    <div>
      <span className="block mb-4 text-sm font-medium tracking-widest text-gray-600 uppercase"><LinkIcon className="inline-block" /> Purchase Tickets</span>

      <ul className='flex flex-col space-y-4'>
        {products?.map((product) => <li key={product._key}><button type="submit" className="inline-flex items-center px-2.5 py-1.5 bg-indigo-600 border border-transparent rounded-md shadow-sm text-xs font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 snipcart-add-item"
          data-item-name={product?.title}
          data-item-id={product?.slug}
          data-item-price={product?.price}
          data-item-url={url}
          data-item-description={product?.description}
          data-item-image={urlFor(product?.mainImage?.image?.asset).auto('format').width(100).height(100).url() || image}
          data-item-taxable={product?.taxable === true ? 'true' : 'false'}
          data-item-has-taxes-included={product?.taxIncluded === true ? 'true' : 'false'}
          data-item-shippable={product?.shipping === true ? 'true' : 'false'}
          data-item-weight={(product?.shipping && product?.type === 'physical' && product?.weight) && product?.weight}
          data-item-length={(product?.shipping && product?.type === 'physical' && product?.length) && product?.length}
          data-item-height={(product?.shipping && product?.type === 'physical' && product?.height) && product?.height}
          data-item-width={(product?.shipping && product?.type === 'physical' && product?.width) && product?.width}
          data-item-max-quantity={product?.maxQuantity}
          data-item-min-quantity={product?.minQuantity}
        >Buy {product?.title} ${product?.price}</button>
        </li>)}
      </ul>

    </div>
  )
}
